/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { Checkbox, Image, message, Popconfirm } from 'antd';
import { bubbleSpriteApi } from 'apis/platform/bubbleSpriteApis';
import CapsuleButton from 'components/button/CapsuleButton';
import NoImage from 'components/etc/NoImage';
import DefaultLayout from 'components/layout/DefaultLayout';
import SearchInput from 'components/search/SearchInput';
import TableToolbar from 'components/table/TableToolbar';
import MainTable from 'components/table/MainTable';
import SpriteRegisterModal from './SpriteRegisterModal';
import SpriteUpdateModal from './SpriteUpdateModal';
import DefaultButton from 'components/button/DefaultButton';
import TextButton from 'components/button/TextButton';
import DeletePopConfirm from 'components/button/DeletePopConfirm';
import { useTranslation } from 'react-i18next';
/**
 * * 플랫폼 관리 - 말풍선 이미지 목록 (sprite)
 */

const SpriteLIstPage = () => {
  const { t } = useTranslation();
  const [{ platformAuth = 'false', loginAdmin }] = useCookies();
  const [templateData, setTemplateData] = useState(); // 템플릿 데이터 담기
  const [visible, setVisible] = useState({
    register: false,
    update: false,
  });
  const [searchData, setSearchData] = useState();
  const [datas, setDatas] = useState();
  const [updateDatas, setUpdateDatas] = useState();

  const handleVisible = (record) => (e) => {
    const { name } = e.target;
    setVisible({ ...visible, [name]: true });
    if (record) {
      setUpdateDatas(record);
    }
  };

  /// 말풍선 이미지 삭제
  const handleDelete = (record) => async () => {
    await bubbleSpriteApi.delete(record.bubble_sprite_id);
    fetchData();

    message.success(t('sprite.table.deleteSuccess'));
  };

  const fetchData = async () => {
    const res = await bubbleSpriteApi.read();
    setDatas(res);
    // 템플릿 리스트 불러오기(필터링하기 위해 필요)
    const templateRes = await bubbleSpriteApi.fetchTemplateList();
    templateRes.forEach((v) => {
      v.text = v.code_name;
      v.value = v.code;
    });
    setTemplateData(templateRes);
  };

  const columnOrigin = [
    {
      title: 'ID',
      dataIndex: 'bubble_sprite_id',
      width: '8rem',
    },
    {
      title: t('sprite.table.template'),
      dataIndex: 'template',
      width: '10rem',
      render: (text, record, index) => (
        <>
          {templateData &&
            templateData.map(
              (v, i) =>
                v.code === record.template && (
                  <span key={i}>{v.code_name}</span>
                ),
            )}
        </>
      ),
      filters: templateData,
      onFilter: (value, record) => record.template.indexOf(value) === 0,
    },
    {
      title: t('sprite.table.name'),
      dataIndex: 'image_name',
      width: '20rem',
      render: (text, record) => (
        <TextButton
          disabled={JSON.parse(platformAuth)}
          onClick={handleVisible(record)}
          name='update'
        >
          {text}
        </TextButton>
      ),
    },
    {
      title: t('sprite.table.image'),
      dataIndex: 'image_url',
      width: '15rem',
      align: 'center',
      render: (text, record) => {
        return record.image_url === null ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <NoImage
              conWidth='50px'
              conHeight='50px'
              imgWidth='35px'
              imgHeight='35px'
            />
          </div>
        ) : (
          <Image src={record.image_url} height={50} alt='말풍선 이미지' />
        );
      },
    },
    {
      title: t('sprite.table.resizable'),
      dataIndex: 'is_slice',
      width: '7rem',
      align: 'center',
      render: (text, record) => (
        <Checkbox disabled checked={record.is_slice === 1 && true} />
      ),
    },
    {
      title: 'Border',
      children: [
        {
          title: t('sprite.table.left'),
          dataIndex: 'border_left',
          align: 'center',
        },
        {
          title: t('sprite.table.right'),
          dataIndex: 'border_right',
          align: 'center',
        },
        {
          title: t('sprite.table.top'),
          dataIndex: 'border_top',
          align: 'center',
        },
        {
          title: t('sprite.table.bottom'),
          dataIndex: 'border_bottom',
          align: 'center',
        },
      ],
    },
    {
      title: t('sprite.table.action'),
      width: '15rem',
      align: 'center',
      render: (text, record) => (
        <DeletePopConfirm
          title={t('sprite.table.delete')}
          onConfirm={handleDelete(record)}
          disabled={JSON.parse(platformAuth)}
        />
      ),
    },
  ];

  useEffect(() => {
    fetchData().catch(console.log);
  }, []);
  return (
    <DefaultLayout>
      <TableToolbar>
        <SearchInput
          placeholder={t('sprite.header.inputPlaceHolder')}
          setSearchData={setSearchData}
        />
        {/* kjiyu, 왜 널값을 줬냐면.. 하이오더로 했을 때 페이지호출 시 오류뜨는거 방지하려고 */}
        <DefaultButton
          name='register'
          onClick={handleVisible(null)}
          disabled={JSON.parse(platformAuth)}
        >
          {t('sprite.header.addSpeechBubbleImage')}
        </DefaultButton>
      </TableToolbar>
      <MainTable
        backgroundColor='#eff2f7'
        columns={columnOrigin}
        dataSource={
          searchData
            ? datas.filter((data) => data.image_name.indexOf(searchData) !== -1)
            : datas
        }
      />
      {visible.register && (
        <SpriteRegisterModal
          visible={visible.register}
          setVisible={setVisible}
          fetchData={fetchData}
          platform_auth={loginAdmin.platform_auth}
          templateDropdownList={templateData}
          setTemplateDropdownList={setTemplateData}
        />
      )}
      {visible.update && (
        <SpriteUpdateModal
          visible={visible.update}
          setVisible={setVisible}
          record={updateDatas}
          fetchData={fetchData}
          userId={loginAdmin.user_id}
          platform_auth={loginAdmin.platform_auth}
          templateDropdownList={templateData}
          setTemplateDropdownList={setTemplateData}
        />
      )}
    </DefaultLayout>
  );
};
export default SpriteLIstPage;
